import {apiAction} from './helper';

export const GET_MOVEMENT_DATA = apiAction('GET_MOVEMENT_DATA');
export const SET_MOVEMENT_REDUCER_PROPS = 'SET_MOVEMENT_REDUCER_PROPS';
